import { useState } from "react";
import { Button } from "react-bootstrap";
import "./BookNowCall.css";
import CustomerRegistractionForm2 from "../../Customer Panel/Customer_Registraction_Form2";

const BookingComponent = () => {
  const [showBookingModal, setShowBookingModal] = useState(false);

  // Function to open the modal
  const openBookingModal = () => setShowBookingModal(true);

  // Function to close the modal
  const closeBookingModal = () => setShowBookingModal(false);

  return (
    <>
      <div className="cupping-booking">
        <h2>Book Your Session Today!</h2>
        {/* <p>
          Experience the healing benefits of massage therapy. Visit <strong>Shrikrishna
          Arogyam </strong>for good health and relaxation.
        </p> */}
        <Button
          variant="primary"
          className="cupping-btn"
          onClick={openBookingModal}
        >
          Book Now
        </Button>
      </div>

      {/* Show the reusable modal when showBookingModal is true */}
      {showBookingModal && (
        <CustomerRegistractionForm2
          show={showBookingModal}
          handleClose={closeBookingModal}
        />
      )}
    </>
  );
};

export default BookingComponent;
